import { useEffect } from "react";
import logo from "../../../assets/logo.png";
import { TbWorld } from "react-icons/tb";
import { useNavigate } from "react-router-dom";

export default function Navbar() {
  const navigate = useNavigate();

  const handleLogoClick = () => {
    const userData = localStorage.getItem("user");
    const parsedUser = userData ? JSON.parse(userData) : null;

    if (parsedUser?.role === "admin") return navigate("/admin");
    if (parsedUser?.role === "client") return navigate("/client");
    if (parsedUser?.role === "agent") return navigate("/agent");
    if (parsedUser?.role === "sub-admin") return navigate("/agent");

    navigate("/");
  };

  useEffect(() => {
    const userData = localStorage.getItem("user");
    const parsedUser = JSON.parse(userData);
    if (parsedUser) {
      if (parsedUser?.role === "admin") navigate("/admin");
      if (parsedUser?.role === "client") navigate("/client");
      if (parsedUser?.role === "agent") navigate("/agent");
      if (parsedUser?.role === "sub-admin") navigate("/agent");
    }
  }, []);

  return (
    <header className="block absolute top-0 w-full bg-[#005787] text-white px-3 md:px-6 py-4">
      <div className="flex items-center justify-between">
        <div className="flex items-center">
          <button
            type="button"
            onClick={handleLogoClick}
            className="cursor-pointer"
            aria-label="Go to dashboard"
          >
            <img
              loading={"lazy"}
              src={logo}
              alt="World Class Logo"
              width={120}
              height={40}
            />
          </button>
        </div>
        <div className="flex items-center flex-row space-x-1 md:space-x-2 cursor-default">
          <TbWorld className="cursor-pointer text-[#87CA60] h-6 md:h-9 w-6 md:w-9" />
          <h2 className="text-xs md:text-base">
            http://worldclassconsultants.com.au/
          </h2>
        </div>
      </div>
    </header>
  );
}
